import React from 'react';
import {
  Box,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
  Alert,
} from '@mui/material';
import { WaUpload } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { PhotoPickerCore } from '../../../../flow-core/components/PhotoPickerCore';

export const PhotoPickerComponent = new FlowComponent({
  ...PhotoPickerCore,
  renderPreview(properties) {
    return (
      <WaUpload
        kind="photo"
        label={properties.label || 'Upload photos'}
        minimum={properties['min-uploaded-photos']}
        maximum={properties['max-uploaded-photos']}
        description={properties.description || properties['helper-text']}
        properties={properties}
      />
    );
  },
  renderPropertyEditor(properties, onChange) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info">
          PhotoPicker allows users to upload photos from camera or gallery.
        </Alert>

        <TextField
          fullWidth
          label="Field Name"
          value={properties.name || ''}
          onChange={(e) => onChange('name', e.target.value)}
          required
          size="small"
          helperText="Used to identify this field in the form data"
        />

        <TextField
          fullWidth
          label="Label"
          value={properties.label || ''}
          onChange={(e) => onChange('label', e.target.value)}
          required
          size="small"
          inputProps={{ maxLength: 80 }}
          helperText={`${(properties.label || '').length}/80 characters`}
        />

        <FormControl fullWidth size="small">
          <InputLabel>Photo Source</InputLabel>
          <Select
            value={properties['photo-source'] || 'camera_gallery'}
            onChange={(e) => onChange('photo-source', e.target.value)}
            label="Photo Source"
          >
            <MenuItem value="camera_gallery">Camera & Gallery</MenuItem>
            <MenuItem value="camera">Camera Only</MenuItem>
            <MenuItem value="gallery">Gallery Only</MenuItem>
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Helper Text"
          value={properties['helper-text'] || ''}
          onChange={(e) => onChange('helper-text', e.target.value)}
          size="small"
        />

        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          Upload Limits
        </Typography>

        <TextField
          fullWidth
          label="Max File Size (bytes)"
          type="number"
          value={properties['max-file-size'] || ''}
          onChange={(e) => onChange('max-file-size', e.target.value)}
          size="small"
          helperText="E.g., 5242880 for 5MB"
          inputProps={{ min: 1 }}
        />

        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            label="Min Photos"
            type="number"
            value={properties['min-uploaded-photos'] || ''}
            onChange={(e) => onChange('min-uploaded-photos', e.target.value)}
            size="small"
            sx={{ flex: 1 }}
            inputProps={{ min: 0 }}
          />
          <TextField
            label="Max Photos"
            type="number"
            value={properties['max-uploaded-photos'] || ''}
            onChange={(e) => onChange('max-uploaded-photos', e.target.value)}
            size="small"
            sx={{ flex: 1 }}
            inputProps={{ min: 1 }}
          />
        </Box>

        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          Validation
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={properties.required || false}
              onChange={(e) => onChange('required', e.target.checked)}
            />
          }
          label="Required"
        />

        <TextField
          fullWidth
          label="Error Message"
          value={properties['error-message'] || ''}
          onChange={(e) => onChange('error-message', e.target.value)}
          size="small"
          helperText="Custom error message when validation fails"
        />

        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          State
        </Typography>

        <FormControlLabel
          control={
            <Switch
              checked={properties.enabled !== false}
              onChange={(e) => onChange('enabled', e.target.checked)}
            />
          }
          label="Enabled"
        />

        <FormControlLabel
          control={
            <Switch
              checked={properties.visible !== false}
              onChange={(e) => onChange('visible', e.target.checked)}
            />
          }
          label="Visible"
        />
      </Box>
    );
  },
});
